import { IFieldsSourceDIS } from "src/app/interfaces/shared/fields-source-dis.interface"

export const FieldsSourceDIS: IFieldsSourceDIS[] = [
  {
    "country": "ar",
    "fields": [
      {
        "field": "fuente_tipo",
        "type": "text",
        "value": "M"
      },
      {
        "field": "operacion_tipo",
        "type": "text",
        "value": "MODIF"
      },
      {
        "field": "usuario",
        "type": "user"
      },
      {
        "field": "fuente",
        "type": "fuente"
      },
      {
        "field": "operacion_fh",
        "type": "current_date"
      },
      {
        "field": "fuente_fh",
        "type": "current_date_adding"
      }
    ]
  },
  {
    "country": "py",
    "fields": [
      {
        "field": "operacion_tipo",
        "type": "text",
        "value": "MODIF"
      },
      {
        "field": "operationType",
        "type": "text",
        "value": "MODIF"
      },
      {
        "field": "fuente_tipo",
        "type": "text",
        "value": "M"
      },
      {
        "field": "sourceType",
        "type": "text",
        "value": "M"
      },
      {
        "field": "usuario_modificacion",
        "type": "user"
      },
      {
        "field": "userModification",
        "type": "user"
      },
      {
        "field": "fecha_insercion",
        "type": "current_date_time"
      }
    ]
  }
];
